import { ref, Ref, watchEffect } from "vue"
import { commentsApi } from "../store/api"
import { ResponseError } from "../interfaces/error.interface"
import { Comment, Post } from "suus-api"

export default function useUpdatePostComment(comment: Comment) {
  const updatedComment: Ref<Comment | null> = ref(null)
  const isSuccess: Ref<boolean> = ref(false)
  const error: Ref<ResponseError | null> = ref(null)
  const isPending: Ref<boolean> = ref(false)

  async function updatePostComment(): Promise<void> {
    isSuccess.value = false
    isPending.value = true
    error.value = null
    try {
      const { data } = await commentsApi.updateComment(comment.id.toString(), {
        text: comment.text,
      })
      updatedComment.value = data
      isSuccess.value = true
    } catch (err: ResponseError) {
      error.value = err
    } finally {
      isPending.value = false
    }
  }

  watchEffect(updatePostComment)

  return {
    updatedComment,
    isPending,
    isSuccess,
    error,
  }
}
